if (!customElements.get('single-or-pair')) {
  customElements.define('single-or-pair', class SingleOrPair extends HTMLElement {
    constructor() {
      super();

      this.buttons = this.querySelectorAll('button[data-quantity]');

      this.buttons.forEach((elem) => {
        elem.addEventListener('click', this.updateQuantity.bind(this));
      });
    }

    updateQuantity(event) {
      event.target.closest('form').querySelector('input[name="quantity"]').value = event.currentTarget.dataset.quantity;
    }
  });
}
